import { useEffect, useState } from "react";

//MUI components
import { Autocomplete, FormControl } from "@mui/material";
import { styled } from "@mui/material/styles";

//AJCE components
import { useMaterialUIController } from "context";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDBox from "components/MDBox";
import { useSearchParams } from "react-router-dom";
import { searchStudent } from "framework/students/advanced_search";
import { getStudentNames } from "framework/students/advanced_search";

const CustomFormControl = styled(FormControl)(({ theme }) => {
  const { palette } = theme;
  return {
    "& .MuiOutlinedInput-root": {
      height: "37.25px",
      "& fieldset": {
        border: "1px solid #bababa",
      },
    },
    "& .MuiOutlinedInput-root.Mui-error": {
      "& fieldset": {
        border: `2px solid ${palette.error.main}`,
      },
      "&:hover fieldset": {
        border: `2px solid ${palette.error.main}`,
      },
    },
  };
});

function FilterSection({ loadingState, resultState, setSnackbar }) {
  const [isLoading, setIsLoading] = loadingState;
  const [result, setResult] = resultState;
  const [options, setOptions] = useState([]);

  const [searchParams, setSearchParams] = useSearchParams();
  const [query, setQuery] = useState(searchParams.get("query") ?? "");
  const [MUIController] = useMaterialUIController();

  useEffect(async () => {
    await handleSearch();
    await fetchNames();
  }, []);

  async function fetchNames() {
    try {
      const newResult = await getStudentNames();
      if (newResult?.length !== 0) {
        setOptions(newResult);
      }
    } catch (err) {}
  }

  async function handleSearch(searchQuery) {
    if (!query && !searchQuery) return;
    try {
      setResult([]);
      setIsLoading(true);
      const newResult = await searchStudent(searchQuery ?? query);
      if (newResult.length === 0) {
        setSnackbar({
          description: "No results found.",
          type: "info",
          icon: "info",
        });
      } else {
        setResult(newResult);
        setQuery("");
      }
    } catch (err) {
      console.error(err);
      const msg = "Something went wrong while searching try again.";
      setSnackbar({
        description: err?.message ?? msg,
        type: "error",
        icon: "error",
      });
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <>
      <MDBox
        display="flex"
        flexDirection={{ xs: "column", md: "row", lg: "row" }}
        justifyContent="center"
        alignItems="center"
        p={2}
      >
        <MDBox display="flex" alignItems="center" minWidth="12rem" width={"100%"} m={1}>
          <CustomFormControl fullWidth size="small">
            <Autocomplete
              disablePortal
              freeSolo
              disableClearable
              id="search-auto-complete"
              options={options}
              onChange={async (e, newval) => {
                setSearchParams({ query: newval });
                await handleSearch(newval);
              }}
              inputValue={query}
              onInputChange={async (e, newval) => {
                setQuery(newval);
              }}
              renderInput={(params) => (
                <MDInput
                  {...params}
                  fullWidth
                  variant="outlined"
                  label="Type admission number or name"
                />
              )}
            />
          </CustomFormControl>
        </MDBox>

        {/* <MDBox display="flex" alignItems="center" minWidth="12rem" width={"100%"} m={1}>
          <CustomFormControl fullWidth size="small">
            <InputLabel id="branch-select-label">Branch</InputLabel>
            <Select
              labelId="branch-select-label"
              id="branch-select"
              label="Branch"
              value={filter.branch}
              onChange={(e) => {
                setFilter((prev) => {
                  return { ...prev, branch: e.target.value };
                });
              }}
            >
              {branches.map((branch) => (
                <MenuItem value={branch} key={`id-${branch}`}>
                  {branch !== "" ? branch : "--- No Selection ---"}
                </MenuItem>
              ))}
            </Select>
          </CustomFormControl>
        </MDBox> */}
        {/* <MDBox display="flex" alignItems="center" minWidth="12rem" width={"100%"} m={1}>
          <CustomFormControl size="small" fullWidth>
            <InputLabel id="sem-select-label">Semester</InputLabel>
            <Select
              labelId="sem-select-label"
              id="sem-select"
              label="Semester"
              value={filter.sem}
              onChange={(e) => {
                setFilter((prev) => {
                  return { ...prev, sem: e.target.value };
                });
              }}
            >
              {semesters.map((semester) => (
                <MenuItem value={semester} key={`id-${semester}`}>
                  {semester !== "" ? semester : "--- No Selection ---"}
                </MenuItem>
              ))}
            </Select>
          </CustomFormControl>
        </MDBox> */}
        <MDBox display="flex" alignItems="center" width="100%" m={1}>
          <MDButton
            fullWidth
            variant="gradient"
            color={MUIController.sidenavColor}
            disabled={isLoading}
            onClick={async (e) => {
              if (query) {
                setSearchParams({ query });
                await handleSearch();
              }
            }}
          >
            Search
          </MDButton>
        </MDBox>
      </MDBox>
    </>
  );
}

export default FilterSection;
